import React from 'react';
import Select from 'react-select-plus';
import { createEvent } from '../helpers';

const SelectMulti = ({
  value,
  onChange,
  name,
  options = [],
  clearable = false,
  ...props
}) => {
  return (
    <Select
      id={name}
      value={value}
      options={options}
      onCloseResetsInput={false}
      onSelectResetsInput={false}
      onChange={(options) =>
        onChange(
          createEvent({ name, value: options.map((option) => option.value) })
        )
      }
      multi={true}
      {...props}
    />
  );
};

export default SelectMulti;
